module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Desktop@2x.7fedbb17.jpg";